var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.534.195h48v48h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.365 5.633c2.48-.599 8.709-.307 10.743 0 .781.118 1.047 1.168 1.486 1.845 1.073 1.655 1.844 3.642 2.564 5.686l-3.402 1.83-.648-1.616-.411 8.699h-9.933l-.411-8.677-.63 1.583-3.403-1.83c.955-2.573 2.215-5.722 4.045-7.52Z",
    style: {
      fill: "#b73c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.954 4.811c2.48-.599 8.709-.308 10.743 0 .781.118 1.047 1.168 1.486 1.845 1.073 1.654 1.844 3.642 2.564 5.686l-3.402 1.829-.648-1.615.037 8.699H18.849l.093-8.677-.63 1.583-3.403-1.83c.955-2.574 2.215-5.722 4.045-7.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b73c3c"
    },
    d: "M21.263 4.751h6.047v16.08h-6.047z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.954 4.811c2.48-.599 8.709-.308 10.743 0 .781.118 1.047 1.168 1.486 1.845 1.073 1.654 1.844 3.642 2.564 5.686l-3.402 1.829-.648-1.615.037 8.699H18.849l.093-8.677-.63 1.583-3.403-1.83c.955-2.574 2.215-5.722 4.045-7.52Zm.207.374c2.514-.556 8.5-.266 10.474.032.271.041.43.269.581.52.222.365.4.801.622 1.143.999 1.539 1.729 3.372 2.404 5.266l-2.687 1.445-.477-1.188a.41.41 0 0 0-.792.155l.035 8.286H19.264l.089-8.262a.41.41 0 0 0-.793-.156l-.46 1.154-2.68-1.442c.903-2.414 2.072-5.259 3.74-6.953h.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m21.263 4.751 3.023 1.15 3.024-1.14v-.666l-3.024.716-3.11-.621.087.561Z",
    style: {
      fill: "#fff261"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.857 4.814a.409.409 0 0 0 .26.321l3.023 1.15a.41.41 0 0 0 .291.001l3.024-1.14a.41.41 0 0 0 .266-.385v-.666a.412.412 0 0 0-.506-.4l-2.936.695-3.023-.603a.41.41 0 0 0-.486.466l.087.561Zm.406-.063 3.023 1.15 3.024-1.14v-.666l-3.024.716-3.11-.621.087.561ZM27.771 9.481h-2.093v1.912l1.013 1.033 1.08-1.033V9.481Zm-.476.454v1.271l-.593.567-.548-.559V9.935h1.141Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.628 9.619h-1.807v1.733l.875.937.932-.937V9.619Z",
    style: {
      fill: "#fff261"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.633 10.796c2.874-.694 10.094-.356 12.451 0 .905.137 1.213 1.354 1.722 2.138 1.244 1.918 2.138 4.221 2.971 6.59l-3.943 2.12-.75-1.872-.477 10.081H7.096l-.477-10.055-.73 1.834-3.943-2.121c1.107-2.982 2.567-6.631 4.687-8.715Z",
    style: {
      fill: "#b73c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.157 9.843c2.874-.694 10.093-.356 12.45 0 .905.137 1.214 1.354 1.723 2.139 1.244 1.917 2.137 4.22 2.971 6.589l-3.943 2.12-.751-1.872.043 10.082H6.035l.108-10.056-.73 1.834-3.943-2.121c1.106-2.982 2.567-6.631 4.687-8.715Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b73c3c"
    },
    d: "M8.833 9.774h7.008v18.635H8.833z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.157 9.843c2.874-.694 10.093-.356 12.45 0 .905.137 1.214 1.354 1.723 2.139 1.244 1.917 2.137 4.22 2.971 6.589l-3.943 2.12-.751-1.872.043 10.082H6.035l.108-10.056-.73 1.834-3.943-2.121c1.106-2.982 2.567-6.631 4.687-8.715Zm.241.434c2.913-.644 9.85-.308 12.138.037.313.048.498.312.673.602.257.424.464.929.721 1.325 1.157 1.784 2.003 3.908 2.785 6.104l-3.113 1.674-.553-1.377a.477.477 0 0 0-.918.179l.041 9.603H6.517l.102-9.574a.476.476 0 0 0-.919-.182l-.532 1.338-3.107-1.671c1.047-2.797 2.401-6.095 4.335-8.058h.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m8.833 9.774 3.504 1.333 3.504-1.321v-.773l-3.504.83-3.605-.719.101.65Z",
    style: {
      fill: "#fff261"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.362 9.847a.477.477 0 0 0 .302.372l3.504 1.333a.477.477 0 0 0 .337.001l3.504-1.321a.476.476 0 0 0 .308-.446v-.773a.473.473 0 0 0-.181-.373.472.472 0 0 0-.405-.09l-3.403.806-3.502-.699a.474.474 0 0 0-.564.54l.1.65Zm.471-.073 3.504 1.333 3.504-1.321v-.773l-3.504.83-3.605-.719.101.65ZM16.375 15.256H13.95v2.216l1.174 1.197 1.251-1.197v-2.216Zm-.551.525v1.474l-.687.657-.635-.647v-1.484h1.322Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.21 15.415h-2.095v2.009l1.014 1.085 1.081-1.085v-2.009Z",
    style: {
      fill: "#fff261"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.251 10.796c2.874-.694 10.093-.356 12.451 0 .904.137 1.213 1.354 1.722 2.138 1.244 1.918 2.137 4.221 2.971 6.59l-3.943 2.12-.75-1.872-.477 10.081H29.714l-.477-10.055-.73 1.834-3.943-2.121c1.106-2.982 2.567-6.631 4.687-8.715Z",
    style: {
      fill: "#b73c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.775 9.843c2.874-.694 10.093-.356 12.45 0 .905.137 1.214 1.354 1.722 2.139 1.244 1.917 2.138 4.22 2.972 6.589l-3.943 2.12-.751-1.872.043 10.082H28.653l.108-10.056-.73 1.834-3.943-2.121c1.106-2.982 2.567-6.631 4.687-8.715Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b73c3c"
    },
    d: "M31.451 9.774h7.008v18.635h-7.008z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.775 9.843c2.874-.694 10.093-.356 12.45 0 .905.137 1.214 1.354 1.722 2.139 1.244 1.917 2.138 4.22 2.972 6.589l-3.943 2.12-.751-1.872.043 10.082H28.653l.108-10.056-.73 1.834-3.943-2.121c1.106-2.982 2.567-6.631 4.687-8.715Zm.241.434c2.913-.644 9.85-.308 12.138.037.313.048.497.312.673.602.257.424.464.929.721 1.325 1.157 1.784 2.003 3.908 2.785 6.104l-3.113 1.674-.553-1.377a.477.477 0 0 0-.918.179l.041 9.603H29.135l.102-9.574a.476.476 0 0 0-.919-.182l-.532 1.338-3.107-1.671c1.047-2.797 2.401-6.095 4.335-8.058h.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m31.451 9.774 3.504 1.333 3.504-1.321v-.773l-3.504.83-3.605-.719.101.65Z",
    style: {
      fill: "#fff261"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.98 9.847a.476.476 0 0 0 .301.372l3.504 1.333a.48.48 0 0 0 .338.001l3.504-1.321a.477.477 0 0 0 .308-.446v-.773a.473.473 0 0 0-.181-.373.472.472 0 0 0-.405-.09l-3.403.806-3.503-.699a.475.475 0 0 0-.564.54l.101.65Zm.471-.073 3.504 1.333 3.504-1.321v-.773l-3.504.83-3.605-.719.101.65ZM38.993 15.256h-2.425v2.216l1.174 1.197 1.251-1.197v-2.216Zm-.552.525v1.474l-.687.657-.635-.647v-1.484h1.322Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.828 15.415h-2.095v2.009l1.014 1.085 1.081-1.085v-2.009Z",
    style: {
      fill: "#fff261"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.312 16.089c4.425-1.068 15.537-.548 19.166 0 1.393.211 1.868 2.084 2.651 3.292 1.915 2.952 3.291 6.497 4.574 10.143l-6.069 3.264-1.156-2.882-.733 15.519h-17.72l-.734-15.48-1.124 2.824-6.07-3.264c1.703-4.591 3.952-10.208 7.215-13.416Z",
    style: {
      fill: "#b73c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.579 14.623c4.424-1.069 15.537-.549 19.166 0 1.393.21 1.868 2.083 2.651 3.291 1.915 2.952 3.29 6.497 4.574 10.143l-6.07 3.264-1.155-2.882.066 15.519H14.392l.166-15.479-1.124 2.823-6.07-3.264c1.703-4.591 3.952-10.208 7.215-13.415Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b73c3c"
    },
    d: "M18.699 14.515h10.788V43.2H18.699z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.579 14.623c4.424-1.069 15.537-.549 19.166 0 1.393.21 1.868 2.083 2.651 3.291 1.915 2.952 3.29 6.497 4.574 10.143l-6.07 3.264-1.155-2.882.066 15.519H14.392l.166-15.479-1.124 2.823-6.07-3.264c1.703-4.591 3.952-10.208 7.215-13.415Zm.371.667c4.484-.992 15.163-.475 18.685.058.482.073.766.479 1.036.926.395.652.714 1.429 1.11 2.039 1.781 2.746 3.083 6.016 4.288 9.396l-4.793 2.578-.851-2.121a.734.734 0 0 0-1.414.276l.063 14.783H15.133l.158-14.738a.734.734 0 0 0-1.415-.28l-.819 2.06-4.783-2.572c1.612-4.307 3.697-9.383 6.674-12.404l.002-.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m18.699 14.515 5.393 2.052 5.394-2.033v-1.189l-5.394 1.278-5.548-1.108.155 1Z",
    style: {
      fill: "#fff261"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.974 14.628c.04.26.217.479.464.573l5.394 2.052a.73.73 0 0 0 .519 0l5.394-2.032a.735.735 0 0 0 .475-.687v-1.189a.733.733 0 0 0-.903-.714l-5.238 1.241-5.392-1.076a.733.733 0 0 0-.868.832l.155 1Zm.725-.113 5.393 2.052 5.394-2.033v-1.189l-5.394 1.278-5.548-1.108.155 1ZM30.309 22.954h-3.734v3.412l1.807 1.842 1.927-1.842v-3.412Zm-.85.809v2.268l-1.057 1.012-.977-.997v-2.283h2.034Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.054 23.2H26.83v3.092l1.561 1.671 1.663-1.671V23.2Z",
    style: {
      fill: "#fff261"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.e08a1c7cd6a2e28d23a054aadc82a86f.svg";
export { ForwardRef as ReactComponent };